export default "__VITE_ASSET__56392f29__"